import {Component} from 'react';
import React from 'react';
import {connect} from 'react-redux';

export class StatusComponent extends Component {
  render = () => {
    let items = [];
    let index = 0;
    for (let [_id, errors] of this.props.errors) {
      index += 1;
      for (let error of errors) {
        items.push(
          <div key={index}>
            {error.message}
          </div>
        );
      }
    }
    let classes = [];
    if (items.length > 0) {
      classes.push('save_status_unhappy');
    }
    return (
      <div id="react-status">
        <div className={classes.join(' ')}>{items}</div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    errors: state.status.errors,
  };
}

export const Status = connect(mapStateToProps)(StatusComponent);
